import Info8Content from '../components/info/Info8PageContent';

const Info8Page = () => {
  return <Info8Content />;
};

export default Info8Page;